import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { CardContainer } from "@msys/ui";
import { Phone as PhoneIcon } from "@mui/icons-material";
import { List } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { MxCallListItem } from "../../mx-calls/MxCallListItem.js";
import { useCrmCompanyMxCallsBoxQuery } from "./CrmCompanyMxCallsBox.generated.js";

interface Props {
  crmCompanyId: string;
}

export const CrmCompanyMxCallsBox = ({ crmCompanyId }: Props) => {
  const { t } = useTranslate(["CrmOrganisations", "Global"]);
  const client = useApolloClient();

  const { data, loading } = useCrmCompanyMxCallsBoxQuery({
    client,
    variables: { crmCompanyId },
  });

  const mxCallsConnection = getDataOrNull(data?.mxCalls);
  const calls = mxCallsConnection?.edges.map(edge => edge.node) ?? [];

  return calls.length > 0 ? (
    <CardContainer
      Icon={<PhoneIcon />}
      title={t("Calls", { ns: "CrmOrganisations" })}
      isExpandable
      isInitiallyClosed={false}
      itemCount={mxCallsConnection?.totalCount}
      isLoading={loading}
    >
      <List disablePadding>
        {calls.map(call => (
          <MxCallListItem key={call.id} call={call} />
        ))}
      </List>
    </CardContainer>
  ) : null;
};
